import React from 'react';
import PropTypes from 'prop-types';
import { Image } from 'react-bootstrap';

const BrandLogo = ({ ignisLogo }) => (
  <div style={{ textAlign: 'center', marginTop: 10 }}>
    <Image src={ignisLogo} style={{ width: '45%' }} />
  </div>
);

BrandLogo.propTypes = {
  ignisLogo: PropTypes.string.isRequired
};

export default BrandLogo;
